import * as React from "react";
import {
  ArrowBackIcon,
  BedIcon,
  MeasureIcon,
  NextIcon,
  PreviousIcon,
  ShowerIcon,
  StarFilledIcon,
  StarIcon,
} from "../../icons";
import { TrendUpIcon } from "../../icons";
import "./index.css";
import { Link, NavLink } from "react-router-dom";
import storageService from "../../../app/services/storageService";
import Observer from '@researchgate/react-intersection-observer'
import { Carousel } from "react-responsive-carousel";
export const ListingFlag = ({ children, type }) => {
  const isNewlyPosted = type === "newly-posted";
  return (
    <div
      className={`flex-row tile-flag ${isNewlyPosted ? "newly-posted-flag" : ""}`}
    >
      {isNewlyPosted ? (
        <StarFilledIcon fill={"var(--orange)"} size={"15"} />
      ) : (
        <TrendUpIcon size={"15"} />
      )}
      {children}
    </div>
  );
};

const ListingTile = ({
  images,
  title,
  type = "featured" | "new-listing",
  price,
  rate,
  facilities,
  onIntersection,
  sqft,
  id,
} = {}) => {
  const orElse = () => { }
  console.log(type)
  return (
    <Observer onChange={onIntersection || orElse} threshold={1}>
      <NavLink to={`/listing/${id}`} className="featured-tile flex-col">
        {type ? (
          <ListingFlag type={type}>
            {type === "featured" ? "FEATURED" : "NEWLY POSTED"}
          </ListingFlag>
        ) : undefined}
        {images.length === 0 ? (<img src={`https://i.imgur.com/6p9udbl.png`} style={{
          objectFit: "cover"
        }} alt={title} className="featured-image" />) : (
          <Carousel width={"100%"} showThumbs={false} swipeable={false} renderArrowPrev={(onClick, hasPrev) => {
            return (
              <div className="listing-tile-carousel-arrow left">
                <button className="listing-tile-carousel-button" disabled={
                  !hasPrev
                } onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  onClick()
                }}>
                  <ArrowBackIcon size={15} stroke={"black"} />
                </button>
              </div>
            );
          }}
            renderArrowNext={(onClick, hasNext) => {
              return (
                <div className="listing-tile-carousel-arrow right">
                  <button className="listing-tile-carousel-button" disabled={
                    !hasNext
                  } onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    onClick()
                  }}>
                    <ArrowBackIcon size={15} stroke={'black'} style={{
                      transform: "rotate(180deg)"
                    }} />
                  </button>
                </div>
              );
            }}
            showStatus={false}
            >
            {images.map((image, i) => {
              return (
                <div key={i}>
                  <img
                    src={`${storageService.publicUrl(image)}`}
                    alt="listing"
                    className="featured-image"
                  />
                </div>
              );
            })}
          </Carousel>
        )}
        <div className="featured-tile-text flex-col">
          <span className="featured-title">{title}</span>
          <div className="featured-price-rate">
            {price && <span className="featured-price">${price}</span>}&nbsp;
            {rate && <span className="featured-rate">/{rate}</span>}
          </div>
        </div>
        <div className="featured-tile-footer">
          {
            facilities.map(e => {
              if (e.quantity === 0) {
                return <></>
              }
              return (
                <span className="featured-tile-footer-icon">
                  {e.facility.name === "Bathrooms" ? <ShowerIcon size={20} /> : <BedIcon size={20} />}{e.quantity}&nbsp;{e.facility.name}
                </span>
              )
            })
          }
          {sqft && (
            <span className="featured-tile-footer-icon">
              <MeasureIcon size={20} />
              {sqft} sf
            </span>
          )}
        </div>
      </NavLink>
    </Observer>
  );
};

export default ListingTile;
